import axios, { AxiosError, AxiosResponse } from 'axios'
import { signFormat, getToken } from './utils'

const request = axios.create({
  baseURL: `https://${process.env.ENV !== "production" ? "testh5api" : "h5api"}.onemt.co/`,
  timeout: 60000, // 请求超时时间
  headers: {
      "Content-Type": "application/json"
  }
});

const errorHandler = (error: AxiosError) => {
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use((config) => {
  if (window.inSDK) {
    config.headers['ONEMT-SOURCE'] = 'game'
  }
  config.headers['ONEMT-TOKEN'] = getToken()
  config.data = signFormat(Object.assign({}, config.data))
  return config;
}, errorHandler);

request.interceptors.response.use((response: AxiosResponse) => {
  return response
}, errorHandler);

export default request